import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Media = () => {
  return <ModulePlaceholder moduleKey="media" />;
};

export default Media;
